import { render, staticRenderFns } from "./AddBalanceSecondStepModal.vue?vue&type=template&id=03282956"
import script from "./AddBalanceSecondStepModal.vue?vue&type=script&lang=js"
export * from "./AddBalanceSecondStepModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports